import { ToolsType } from '../../models/layoutClass';
import { LAYOUT_SELECT_VIEW, LAYOUT_SELECT_TOOL, LAYOUT_SELECT_MENU, LAYOUT_SET_LIVE_CONTROLS } from './layoutReducer';

export const selectViewAction = (payload) => {
  return (
    {
      type: LAYOUT_SELECT_VIEW,
      payload
    });
};

export const selectToolAction = (selectedTool: ToolsType) => {
  return (
    {
      type: LAYOUT_SELECT_TOOL,
      payload: selectedTool
    });
};

export const producerMenuAction = (payload) => {
  return (
    {
      type: LAYOUT_SELECT_MENU,
      payload: payload
    });
};
export const setLiveControls = (liveControlsVisible) => {
  return (
    {
      type: LAYOUT_SET_LIVE_CONTROLS,
      payload: {liveControlsVisible}
    });
};

